import Icon from '../Icon';
import { Wrapper } from './styled';

type Props = {
    message?: string;
};

export default function ErrorMessage({ message }: Props) {
    return (
        <Wrapper>
            <Icon name="warning" color="error" />
            {message || 'Något gick fel hos oss. Försök igen senare.'}
        </Wrapper>
    );
}
